app.controller('ConfirmationCtrl', function ($scope, $rootScope, $http, $timeout, $uibModal, loginService) {
    this.user = loginService.currentUser;
    $scope.data = {
        queryParam: {}
    };
    
    this.offerConfirmationModal = (offerDetails, targetAction) => {
        $uibModal
            .open({
                component: 'offer-confirmation',
                windowClass: 'offer-confirmation-modal',
                animation: false,
                size: 'lg',
                resolve: {
                    offerDetails: () => {
                        return offerDetails;
                    },
                    targetAction: () => {
                        return targetAction;
                    }
                }
            })
            .result
            .then(onClose, onClose)
            .catch(onError('offer-confirmation'));
    };

    const checkQueryParam = () => {
        $timeout(() => {
            // console.log($scope.data.queryParam);
            if ($scope.data.queryParam.action == 'confirmation' && $scope.data.queryParam.id) {
                this.loading = true;
                $http
                    .get(`/offer/details/${$scope.data.queryParam.id}`)
                    .then((response) => {
                        // console.log(response.data);
                        if (response.data && response.data.programOffer.id) {
                            this.offerConfirmationModal(response.data, 'accept');
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else if ($scope.data.queryParam.action == 'program-offer-open' && $scope.data.queryParam.id ) {
                $rootScope.$emit("notificationOpenProgramOfferModel", {offerId: $scope.data.queryParam.id});
            }
        }, 100);
    };

    const onClose = () => {
        console.log('cancel action performed');
    };

    const onCancel = () => {
        console.log('cancel action performed');
    };

    const onError = (name) => {
        return (err) => {
            console.log('',err);
        };
    };
    
    checkQueryParam();
});